import { numericFormatter } from "react-number-format";
import { columns } from "../../../../dtos/columns";
import { format } from "rut.js";
import { ListaCargaCobradorDTO } from "../models/cargaCobro";


export function useColumns() {

    const COLUMNS: columns<ListaCargaCobradorDTO>[] = [
        {
            name: 'N° registro',
            selector: (row) =>
                row.numeroRegistro,
            sortable: true,
            sortField: 'numeroRegistro',
            wrap: true,
            export: true
        },
        {
            name: 'N° operación',
            selector: (row) =>
                row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            export: true
        },

        {
            name: 'Rut',
            selector: (row) => row.dv ? `${format(`${row.rut}-${row.dv}`)}` : format(row.rut),
            sortable: true,
            sortField: 'rut',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Mes',
            selector: (row) => row.mes,
            sortable: true,
            sortField: 'mes',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Año',
            selector: (row) => row.ano,
            sortable: true,
            sortField: 'ano',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Numero cuotas',
            selector: (row) => row.numeroCuotas,
            sortable: true,
            sortField: 'numeroCuotas',
            wrap: true,
            export: true,
            alling: 'left'

        },
        {
            name: 'Estado',
            selector: (row) =>
                row.estado,
            sortable: true,
            sortField: 'estado',
            wrap: true,
            export: true,
        },
        {
            name: 'Monto pagar',
            selector: (row) =>
                !row.montoPagar ? "" : numericFormatter(row.montoPagar.toString(), { "thousandsGroupStyle": "thousand", "thousandSeparator": ".", "decimalSeparator": "," }),
            sortable: true,
            sortField: 'montoPagar',
            wrap: true,
            export: true,
        }
    ]


    return { COLUMNS };
}